// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ZI-z","twoColumnImage":"_I-z"};